import Vue from 'vue'

export const actions = {
  ACTIVATED: 'MAP ACTIVATED',
  DEACTIVATED: 'MAP DEACTIVATED',
  SEARCHED_AREA: 'SEARCHED AREA',
  SEARCHED_NEARBY: 'SEARCHED NEARBY',
  CLUSTER_CLICKED: 'CLUSTER CLICKED',
  MARKER_CLICKED: 'MARKER CLICKED',
  FILTERS_SHOW: 'FILTERS SHOW',
  FILTERS_HIDE: 'FILTERS HIDE',
}

const event = 'mapSearchClicked'

const active = (action, viewport = []) => {
  const data = {
    mapsearch: {
      action: actions[action],
      viewport,
    },
    event,
  }

  Vue.$clickstream.trackEvent(data)
}

const events = (action, attrs = {}, viewport = []) => {
  const data = {
    mapsearch: {
      action: actions[action],
      ...attrs,
      viewport: viewport.map(({ lat, lng: long }) => ({ lat, long })),
    },
    event,
  }

  Vue.$clickstream.trackEvent(data)
}

export default {
  active,
  events,
}
